export default __webpack_public_path__ + "assets/img/Options.a054dc85.svg";